export default __webpack_public_path__ + "static/media/sass.2dd903aa.svg";